import React from 'react';
import { Icons } from '../../types/icon-types';
import Styled from './SkiResortAmenities.styled';

const RowStatusIcon = ({ type, color }: { type: Icons; color: string }) => (
  <Styled.RowStatusIcon type={type} style={{ color }} />
);

export default RowStatusIcon;
